import { render, staticRenderFns } from "./DashboardEmailsCard.vue?vue&type=template&id=61d30fdc&"
import script from "./DashboardEmailsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardEmailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports